import { Column, getColumns } from '../../../../utility/decorator/entity/column.decorator';
import { SlackFileDownloadUrl, SlackFileId, SlackFileMimetype, SlackFileName, SlackFilePermalink, SlackFileSize, SlackFileType } from '../value';

import { Entity } from '../../../../utility/model/entity.model';
import { IsDeleted } from '../../../kernel/base/value';
import { SlackMessageId } from '../../slack-message/value';
import { Timestamp } from '../../../../utility/model/timestamp.value';

export class SlackFile implements Entity {
  @Column()
  readonly id: SlackFileId;
  @Column()
  slackMessageId: SlackMessageId;
  @Column()
  name: SlackFileName;
  @Column()
  mimetype: SlackFileMimetype;
  @Column()
  type: SlackFileType;
  @Column()
  size: SlackFileSize;
  @Column()
  downloadUrl: SlackFileDownloadUrl;
  @Column()
  permalink: SlackFilePermalink;
  @Column()
  createdAt: Timestamp;
  @Column()
  updatedAt: Timestamp;
  @Column()
  isDeleted: IsDeleted;

  constructor(id: SlackFileId) {
    this.id = id;
  }

  // Dirty code
  static get allFields(): (keyof SlackFile)[] {
    return getColumns(new SlackFile(SlackFileId.create('')));
  }

  equals(value: SlackFile): boolean {
    return this.id.equals(value.id);
  }
}
